import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { PropTypes, string, bool } from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { shimThdCustomerHook } from '@thd-olt-component-react/cart-common-data';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { isLLc } from '../utils/utils';
import { SavedPaypalButton } from './SavedPaypalButton';
import { PaypalSmartButton } from './PaypalSmartButton';
import { PaypalMessage } from './PaypalMessage';
import { LLC_PAYPAL_TOKEN, PROD_PAYPAL_TOKEN } from '../constants/constants';

const PaypalCheckoutButton = (props) => {
  const {
    hasSavedPaypal,
    payInFour,
    orderTotal,
    orderId,
    isValidCart,
    itemCount,
    fromPage,
    ffm,
    cartRequest,
    hideButton,
    hideMessage
  } = props;
  const isPaypalEnabled = useConfigService('PAYPAL_ENABLE');
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('paypal-checkout-button.ready'); }, []);
  const { isLoggedIn, isPersisted } = shimThdCustomerHook(useThdCustomer());

  if (!isPaypalEnabled) {
    return false;
  }

  const isUserAuth = !isLoggedIn || (isLoggedIn && !isPersisted);

  return (
    <div data-component="PaypalCheckoutButton">
      <PayPalScriptProvider options={{
        clientId: !isLLc() ? PROD_PAYPAL_TOKEN : LLC_PAYPAL_TOKEN,
        enableFunding: 'paylater',
        disableFunding: 'card',
        components: 'buttons,funding-eligibility,messages',
        intent: 'order',
        commit: 'false'
      }}
      >
        <div className="sui-grid sui-grid-cols-2 sui-gap-1">
          {hasSavedPaypal && (
            <div className={payInFour ? '' : 'sui-col-span-2'}>
              <SavedPaypalButton
                payInFour={payInFour}
                isValidCart={isValidCart}
                isAuthUser={isUserAuth}
              />
            </div>
          )}
          {(!hasSavedPaypal || payInFour) && !hideButton
            && (
              <div
                className={
                  (hasSavedPaypal && payInFour)
                    ? 'sui-relative sui-z-0'
                    : 'sui-col-span-2 sui-relative sui-z-0'
                }
                data-testid={(hasSavedPaypal && payInFour) ? 'paypal-pay-in-four-button' : 'paypal-smart-button'}
              >
                {PaypalSmartButton(orderId, payInFour, hasSavedPaypal, cartRequest, itemCount, fromPage, ffm)}
              </div>
            )}
          {(!hideMessage && payInFour) && (
            <div className="sui-col-span-2" data-testid="paypal-pay-in-four-message">
              {PaypalMessage(orderTotal)}
            </div>
          )}
        </div>
      </PayPalScriptProvider>
    </div>
  );
};

PaypalCheckoutButton.propTypes = {
  hasSavedPaypal: bool,
  payInFour: bool,
  isValidCart: bool.isRequired,
  orderId: string,
  orderTotal: string.isRequired,
  itemCount: string.isRequired,
  fromPage: string.isRequired,
  ffm: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cartRequest: PropTypes.object,
  hideButton: bool,
  hideMessage: bool
};

PaypalCheckoutButton.defaultProps = {
  orderId: '',
  cartRequest: null,
  hasSavedPaypal: false,
  payInFour: false,
  hideButton: false,
  hideMessage: false
};

PaypalCheckoutButton.displayName = 'PaypalCheckoutButton';

export { PaypalCheckoutButton };
